import React from 'react';

export default function FSDPlus() {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-slate-100">
      Redirecting...
    </div>
  );
}
